import moment, { Moment } from 'moment';

export const LEGACY_VIEW_ONLY_DATE = '2026-07-30';
export const LEGACY_VIEW_ONLY_WARNING_DATE = '2026-06-30';

export type LegacyProjectBannerPhase =
  | 'preViewOnlyAnnouncement'
  | 'viewOnlyWarning'
  | 'viewOnly';

/**
 * Classic Studio versions subject to legacy retirement view-only.
 * Excludes Universal and Adobe Premiere integrations.
 */
export const isClassicLegacyStudioVersion = (
  studioVersion: string | null | undefined
): boolean => {
  if (!studioVersion) return false;
  if (studioVersion.startsWith('ext_adobe')) return false;
  if (studioVersion === 'universal') {
    return false;
  }
  return true;
};

const VIEW_ONLY_DATE_MOMENT = moment(
  LEGACY_VIEW_ONLY_DATE,
  'YYYY-MM-DD'
).startOf('day');
const VIEW_ONLY_WARNING_DATE_MOMENT = moment(
  LEGACY_VIEW_ONLY_WARNING_DATE,
  'YYYY-MM-DD'
).startOf('day');

export const getLegacyBannerPhase = (
  now: Moment = moment().startOf('day')
): LegacyProjectBannerPhase => {
  const today = now.clone().startOf('day');

  if (today.isSameOrAfter(VIEW_ONLY_DATE_MOMENT)) {
    return 'viewOnly';
  }

  if (today.isSameOrAfter(VIEW_ONLY_WARNING_DATE_MOMENT)) {
    return 'viewOnlyWarning';
  }

  // Tentative start window; kept for QA / testing before announcement launch.
  return 'preViewOnlyAnnouncement';
};

export const isLegacyProjectViewOnly = ({
  studioVersion,
  now = moment().startOf('day'),
}: {
  studioVersion: string | null | undefined;
  now?: Moment;
}): boolean => {
  if (!isClassicLegacyStudioVersion(studioVersion)) return false;
  return getLegacyBannerPhase(now) === 'viewOnly';
};
